// extracted by mini-css-extract-plugin
module.exports = {"commentsCard":"comments_commentsCard__aeRke","greyLabel":"comments_greyLabel__3tmdA","commentText":"comments_commentText__2qOsR"};